import { DependencyList, EffectCallback, useEffect, useRef } from "react";

export const useDebounceEffect = (
  effect: EffectCallback,
  dependencies: DependencyList,
  delay: number,
) => {
  const refTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const refCleanup = useRef<(() => void) | void>(null);

  useEffect(() => {
    refTimeout.current = setTimeout(() => {
      refCleanup.current = effect();
    }, delay);

    return () => {
      if (refTimeout.current) {
        clearTimeout(refTimeout.current);
      }

      if (typeof refCleanup.current === "function") {
        refCleanup.current();
        refCleanup.current = null;
      }
    };
  }, [...dependencies, delay]);
};
